import { render, staticRenderFns } from "./GestionExpedienteProveedor.vue?vue&type=template&id=50993128&scoped=true"
import script from "./GestionExpedienteProveedor.vue?vue&type=script&lang=js"
export * from "./GestionExpedienteProveedor.vue?vue&type=script&lang=js"
import style0 from "./GestionExpedienteProveedor.vue?vue&type=style&index=0&id=50993128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50993128",
  null
  
)

export default component.exports